import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaTourDiViaggio from '../../Components/Galerias/TourDiViaggio';
import Desktop from '../../Components/Desktop';

import tdv1 from '../../Images/Proyectos/tdv.png';
import tdv2 from '../../Images/Proyectos/Galerias/Tour-Di-Viaggio/10.png'


const TourDiViaggio = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>

        <img className="center-img dimensionar-imagen-movil" alt="" src={tdv1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Desarrollamos este sitio web para esta agencia de viajes enfocada a satisfacer a sus <br />
              clientes con hermosos destinos a increíbles precios. <br /><br />
              La página web fue solicitada para dar presencia en el mercado online. <br /><br />
              Estas increíbles personas nos confiaron su emprendimiento y nos pidieron una página <br />
              que pudiera crecer conforme lo hacía la agencia. <br /><br />
              Empezó siendo una landing page sencilla, después evolucionó hasta convertirse en una <br />
              E-commerce la cual ofrece membresías para viajar alrededor del mundo.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Desarrollamos este sitio web para esta agencia de viajes enfocada a satisfacer a sus 
              clientes con hermosos destinos a increíbles precios. <br /><br />
              La página web fue solicitada para dar presencia en el mercado online. <br /><br />
              Estas increíbles personas nos confiaron su emprendimiento y nos pidieron una página 
              que pudiera crecer conforme lo hacía la agencia. <br /><br />
              Empezó siendo una landing page sencilla, después evolucionó hasta convertirse en una 
              E-commerce la cual ofrece membresías para viajar alrededor del mundo. 
            </p>
          )}
        </div>

        <Desktop images={{desktop: "tourDiViaggioDesktop", laptop:"tourDiViaggioLaptop", movil: "tourDiViaggioMovil"}} />

        <div className='container'>
          <GaleriaTourDiViaggio/>
        </div>

        <div className='dimensionar-imagen-td'>
          <img className="center-img" alt="" src={tdv2}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default TourDiViaggio;
